import { render, staticRenderFns } from "./invoiceDetail.vue?vue&type=template&id=52bda0c4&scoped=true"
import script from "./invoiceDetail.vue?vue&type=script&lang=js"
export * from "./invoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetail.vue?vue&type=style&index=0&id=52bda0c4&prod&lang=less&scoped=true"
import style1 from "./invoiceDetail.vue?vue&type=style&index=1&id=52bda0c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bda0c4",
  null
  
)

export default component.exports